import { axiosInstance } from "../axios/axiosConfig";
import { COUPON_API } from "../constants/api-constants";

export const getAllAvailableCoupons = async (couponCode = null) => {
  try {
    const response = await axiosInstance.get(`${COUPON_API.GET_COUPON_API}/AllAvailableCoupons`, {
      params: { couponCode },
    });

    return response.data;
  } catch (error) {
    throw new Error(COUPON_API.GET_COUPON_API_ERROR);
  }
};

export const getRedemptionCoupon = async (code) => {
  try {
    const response = await axiosInstance.get(`${COUPON_API.GET_COUPON_API}/${code}/redemption`);
    return response.data;
  } catch (error) {
    throw new Error(COUPON_API.GET_COUPON_API_ERROR);
  }
};

export const restoreCoupon = async (orderNumber) => {
  try {
    const response = await axiosInstance.post(`${COUPON_API.GET_COUPON_API}/${orderNumber}/RestoreCoupon`);
    return response.data;
  } catch (error) {
    throw new Error(COUPON_API.GET_COUPON_API_ERROR);
  }
};

export const getAllAvailableDirectDeliveryCoupon = async () => {
  try {
    const response = await axiosInstance.get(`${COUPON_API.GET_COUPON_API}/AllAvailableDirectDeliveryCoupon`);

    return response.data;
  } catch (error) {
    throw new Error(COUPON_API.GET_COUPON_API_ERROR);
  }
};

export const checkReferralCouponAvailable = async () => {
  try {
    const response = await axiosInstance.get(`${COUPON_API.GET_COUPON_API}/CheckReferralCouponAvailable`);

    return response.data;
  } catch (error) {
    throw new Error(COUPON_API.GET_COUPON_API_ERROR);
  }
};